module.exports = __webpack_public_path__ + "static/media/dumbell.7828d6ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/dumbell.svg
// module id = ./src/statics/images/dumbell.svg
// module chunks = 0